var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38629 4.58824C6.38629 4.26336 6.66106 4 7 4C7.33894 4 7.61371 4.26336 7.61371 4.58824V6.94118C7.61371 7.26605 7.33894 7.52941 7 7.52941C6.66106 7.52941 6.38629 7.26605 6.38629 6.94118V4.58824Z",
    fill: "#E64539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.23529C6.66106 8.23529 6.38629 8.49866 6.38629 8.82353C6.38629 9.1484 6.66106 9.41176 7 9.41176C7.33894 9.41176 7.61371 9.1484 7.61371 8.82353C7.61371 8.49866 7.33894 8.23529 7 8.23529Z",
    fill: "#E64539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7261 9.11545L13.7295 9.12111C14.5072 10.4205 13.51 12 11.9839 12H2.01608C0.489965 12 -0.507242 10.4205 0.270481 9.12111L0.273868 9.11545L5.2623 0.956636C5.43969 0.66429 5.69385 0.423208 5.9977 0.256031C6.30324 0.0879199 6.64897 0 7 0C7.35103 0 7.69676 0.0879199 8.00231 0.256031C8.30617 0.423222 8.56035 0.664328 8.73774 0.956701L13.7261 9.11545ZM7.46531 1.66778L12.4519 9.82363C12.6563 10.1652 12.3981 10.5882 11.9839 10.5882H2.01608C1.60187 10.5882 1.34366 10.1652 1.54808 9.82363L6.53469 1.66778C6.58154 1.59001 6.64925 1.52537 6.73097 1.48041C6.81269 1.43545 6.9055 1.41176 7 1.41176C7.0945 1.41176 7.18731 1.43545 7.26903 1.48041C7.35075 1.52537 7.41847 1.59001 7.46531 1.66778Z",
    fill: "#E64539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3b27cb69e703810085f18248c1313556.svg";
export { ForwardRef as ReactComponent };